export default __webpack_public_path__ + "static/protected-proposal-ilustration-24ea92ee5d465874f61519d83f1393eb.svg";